/**
 * IMAYO 閲覧履歴機能
 */
(function () {
  var STORAGE_KEY = 'imayo-recently-viewed';
  var MAX_ITEMS = 24;
  var PER_PAGE_PC = 8;
  var PER_PAGE_SP = 2;
  var CONCURRENT_REQUESTS = 4;
  var SECTION_ID = 'imayo-recently-viewed';

  document.addEventListener('DOMContentLoaded', initRecentlyViewed);

  function initRecentlyViewed() {
    var container = document.querySelector('.recentlyViewed');
    if (!container) return;

    var handles = getStoredHandles();
    if (handles.length === 0) {
      container.style.display = 'none';
      return;
    }

    fetchProductCards(handles).then(function (cards) {
      var validCards = cards.filter(function (card) { return card !== null; });
      if (validCards.length === 0) {
        container.style.display = 'none';
        return;
      }
      buildSlides(validCards);
      initSlider();
    });
  }

  // LocalStorageからhandle配列を取得
  function getStoredHandles() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      if (!data) return [];
      var parsed = JSON.parse(data);
      if (!Array.isArray(parsed)) {
        console.error('[RecentlyViewed] Invalid data format, clearing storage');
        localStorage.removeItem(STORAGE_KEY);
        return [];
      }
      return parsed;
    } catch (e) {
      console.error('[RecentlyViewed] LocalStorage not available:', e);
      return [];
    }
  }

  // 並列リクエスト数を制限してSection Rendering APIを呼び出す
  function fetchProductCards(handles) {
    var results = new Array(handles.length).fill(null);
    var index = 0;

    function fetchNext() {
      if (index >= handles.length) return Promise.resolve();
      var currentIndex = index++;
      var handle = handles[currentIndex];
      return fetchSingleCard(handle)
        .then(function (html) { results[currentIndex] = html; })
        .catch(function () { results[currentIndex] = null; })
        .then(fetchNext);
    }

    var workers = [];
    for (var i = 0; i < Math.min(CONCURRENT_REQUESTS, handles.length); i++) {
      workers.push(fetchNext());
    }
    return Promise.all(workers).then(function () { return results; });
  }

  // 1件の商品カードHTMLを取得
  function fetchSingleCard(handle) {
    var url = '/products/' + handle + '?section_id=' + SECTION_ID;
    return fetch(url)
      .then(function (response) {
        if (!response.ok) {
          removeFromStorage(handle);
          throw new Error('Product not found: ' + handle);
        }
        return response.text();
      })
      .then(function (html) {
        return extractCardHtml(html);
      });
  }

  // レスポンスHTMLからカード部分を抽出
  function extractCardHtml(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var card = doc.querySelector('.js-recently-viewed-card');
    return card ? card.innerHTML : null;
  }

  // 不正なhandleをLocalStorageから削除
  function removeFromStorage(handle) {
    try {
      var handles = getStoredHandles();
      var filtered = handles.filter(function (h) { return h !== handle; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch (e) {
      console.error('[RecentlyViewed] Failed to update storage:', e);
    }
  }

  // 1カード=1スライドでDOMに挿入
  function buildSlides(cards) {
    var list = document.querySelector('.js-recently-viewed-list');
    if (!list) return;

    for (var i = 0; i < cards.length; i++) {
      var slide = document.createElement('li');
      slide.className = 'splide__slide c-slide';
      slide.innerHTML = cards[i];
      list.appendChild(slide);
    }
  }

  // Splideスライダーを初期化
  var splideRetryCount = 0;
  function initSlider() {
    if (typeof Splide === 'undefined') {
      if (++splideRetryCount > 10) {
        console.error('[RecentlyViewed] Splide.js not loaded after 10 retries');
        return;
      }
      setTimeout(initSlider, 50);
      return;
    }

    var sliderRoot = document.querySelector('.recentlyViewed-slider .splide');
    if (!sliderRoot) return;

    // SP時: 最後のスライドを左寄せ表示するためスペーサーを動的に管理
    var spMql = window.matchMedia('(max-width: 767px)');
    var spacer = null;
    var list = sliderRoot.querySelector('.splide__list');

    function addSpacer() {
      if (spacer || !list) return;
      spacer = document.createElement('li');
      spacer.className = 'splide__slide';
      spacer.setAttribute('aria-hidden', 'true');
      list.appendChild(spacer);
    }

    function removeSpacer() {
      if (!spacer) return;
      spacer.remove();
      spacer = null;
    }

    if (spMql.matches) {
      addSpacer();
    }

    var splide = new Splide(sliderRoot, {
      type: 'slide',
      perPage: PER_PAGE_PC,
      perMove: PER_PAGE_PC,
      gap: '0px',
      pagination: false,
      arrows: false,
      drag: true,
      speed: 600,
      breakpoints: {
        767: {
          perPage: PER_PAGE_SP,
          perMove: PER_PAGE_SP,
          padding: { left: 16, right: 0 },
          trimSpace: false
        }
      }
    });

    var counter = document.querySelector('.js-recently-viewed-counter');
    var prevBtn = document.querySelector('.js-recently-viewed-prev');
    var nextBtn = document.querySelector('.js-recently-viewed-next');

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () { splide.go('-1'); });
      nextBtn.addEventListener('click', function () { splide.go('+1'); });
    }

    function updateControls() {
      var end = splide.Components.Controller.getEnd();
      var total = end + 1;
      var current = splide.index + 1;
      if (counter) counter.textContent = current + '/' + total;
      if (prevBtn) prevBtn.disabled = (splide.index === 0);
      if (nextBtn) nextBtn.disabled = (splide.index >= end);
    }

    splide.on('mounted move refresh', updateControls);

    splide.mount();

    // ブレークポイント変更時にスペーサーを切り替え + カウンター更新
    spMql.addEventListener('change', function (e) {
      if (e.matches) {
        addSpacer();
      } else {
        removeSpacer();
      }
      splide.refresh();
    });

    // 動的挿入されたカードのサムネイルスライダーを初期化
    if (window.initImayoThumbSliders) {
      window.initImayoThumbSliders();
    }
  }
})();
